const constructGoogleMapsUrl = ({
  lat,
  lon,
}: {
  lat: number;
  lon: number;
}): string => {
  return `https://www.google.com/maps/dir/?api=1&query=${lat},${lon}`;
};

export { constructGoogleMapsUrl };
